import type { NormalisedSignupCode } from '../signup-codes/signup-codes.module.types'

export const moduleName = 'admin/create-signup-code'

export type NormalisedCreateSignupCodeResponse = NormalisedSignupCode
